import React, { Component } from 'react';
import './index.less';
import classnames from 'classnames';

export default class PlatformWrapper extends Component {
  render() {
    const { wrapperRight = '', background = '', className = '', title = '', titleLink = '' } = this.props;
    const innerClassName = classnames('platform-wrapper', className);

    return (
      <div className={innerClassName} style={{ backgroundColor: background }}>
        <div className="platform-title-wrap">
          <div
            className="platform-title"
            onClick={() => titleLink && window.open(titleLink)}
            style={titleLink ? { cursor: 'pointer' } : {}}
          >
            {title}
          </div>
          {wrapperRight}
        </div>
        <div className="platform-inner-wrap">{this.props.children}</div>
      </div>
    );
  }
}
